import React, { useEffect, useState } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import Tabs from '../../components/ui/Tabs';
import { COLORS } from '../../theme';
import { useTituloPagina } from '../../context/PageTitleContext';

import DadosGeraisTab from './tabs/DadosGeraisTab';
import ContatosTab from './tabs/ContatosTab';
import ObservacoesTab from './tabs/ObservacoesTab';
import ComercialTab from './tabs/ComercialTab';
import HistoricoComprasTab from './tabs/HistoricoComprasTab';

const FORM_VAZIO = { ativo: 1 };

export default function CadastroEmpresaForm({
  titulo, api, registroId, onVoltar, onSalvo,
  exibirComercial = true, exibirEnderecosExtras = true, exibirFrete = false, exibirPrazoEntrega = false, exibirHistoricoCompras = false,
  abaExtra
}) {
  const abas = [
    { chave: 'dados', titulo: 'Dados Gerais' },
    ...(abaExtra ? [{ chave: 'extra', titulo: abaExtra.titulo }] : []),
    { chave: 'contatos', titulo: 'Contatos' },
    ...(exibirComercial ? [{ chave: 'comercial', titulo: 'Comercial' }] : []),
    ...(exibirHistoricoCompras ? [{ chave: 'historico', titulo: 'Histórico de Compras' }] : []),
    { chave: 'observacoes', titulo: 'Observações' }
  ];
  const [abaAtiva, setAbaAtiva] = useState('dados');
  const [form, setForm] = useState(FORM_VAZIO);
  const [idAtual, setIdAtual] = useState(registroId || null);
  const [carregando, setCarregando] = useState(!!registroId);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  useEffect(() => {
    if (registroId) {
      api.obter(registroId).then(setForm).finally(() => setCarregando(false)).catch(() => setCarregando(false));
    }
  }, [registroId]); // eslint-disable-line

  const onChange = (campo, valor) => setForm(f => ({ ...f, [campo]: valor }));

  const salvar = async () => {
    if (!form.nome_fantasia) { setErro('Nome Fantasia é obrigatório'); setAbaAtiva('dados'); return; }
    setSalvando(true);
    setErro('');
    try {
      if (idAtual) {
        await api.atualizar(idAtual, form);
      } else {
        const resultado = await api.criar(form);
        setIdAtual(resultado.id);
      }
      if (onSalvo) onSalvo();
    } catch (e) {
      setErro(e.message);
    } finally {
      setSalvando(false);
    }
  };

  useTituloPagina(idAtual ? `${titulo} — ${form.nome_fantasia || ''}` : `Novo ${titulo}`);

  if (carregando) return <p>Carregando...</p>;

  const acaoTabs = (
    <>
      <Btn variante="ghost" onClick={onVoltar}>Voltar</Btn>
      <Btn onClick={salvar} disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar'}</Btn>
    </>
  );

  return (
    <div>
      <Card>
        {erro && <p style={{ color: COLORS.danger, fontSize: 13, marginTop: 0 }}>{erro}</p>}
        <Tabs abas={abas} ativa={abaAtiva} onMudar={setAbaAtiva} acao={acaoTabs} />

        {abaAtiva === 'dados' && <DadosGeraisTab form={form} onChange={onChange} exibirEnderecosExtras={exibirEnderecosExtras} exibirFrete={exibirFrete} exibirPrazoEntrega={exibirPrazoEntrega} />}
        {abaAtiva === 'extra' && abaExtra && <abaExtra.Componente form={form} onChange={onChange} />}
        {abaAtiva === 'contatos' && <ContatosTab registroId={idAtual} api={api} />}
        {abaAtiva === 'comercial' && exibirComercial && <ComercialTab form={form} onChange={onChange} />}
        {abaAtiva === 'historico' && exibirHistoricoCompras && <HistoricoComprasTab fornecedorId={idAtual} />}
        {abaAtiva === 'observacoes' && <ObservacoesTab form={form} onChange={onChange} />}
      </Card>
    </div>
  );
}
